<template>
  <div>
    <filter-data-quality
      v-if="filter.type === 'dataquality' && filter.show"
      :checkboxes="filter.values"
      :options="filter"
      :show="filter.show && filterCategory.open"
      :parameter="filter.name"
      :title="filter.title"
    ></filter-data-quality>
    <filter-multi-select
      v-if="filter.type === 'multiselect' && filter.show"
      :checkboxes="filter.values"
      :options="filter"
      :show="filter.show"
      :single-select-options="filter.singleSelectOptions"
      :parameter="filter.name"
      :title="filter.title"
    ></filter-multi-select>
    <filter-checkbox-group
      v-if="filter.type === 'checkboxgroup' && filter.show"
      :checkboxes="filter.values"
      :options="filter"
      :show="filter.show"
      :single-select-options="filter.singleSelectOptions"
      :parameter="filter.name"
      :title="filter.title"
    ></filter-checkbox-group>
    <filter-check-box
      v-if="filter.type === 'checkbox' && filter.show"
      :options="filter"
      :parameter="filter.parameter"
    ></filter-check-box>
    <filter-range
      v-if="filter.type === 'rangeslider'"
      :standalone-filter="standaloneFilter"
      :options="filter.options"
      :indicator-options="filter.indicatorOptions"
      :description="filter.description"
      :startParameter="filter.startParameter"
      :endParameter="filter.endParameter"
      :title="filter.title"
      :is-felt-egenskap="filter.hasOwnProperty('isFeltEgenskap') ? filter.isFeltEgenskap : true"
      :show-title="filter.hasOwnProperty('showTitle') ? filter.showTitle : false"
      :show-checkbox="filter.hasOwnProperty('showCheckbox') ? filter.showCheckbox : true"
      :filter-active="filter.hasOwnProperty('filterActive') ? filter.filterActive : false"
    ></filter-range>
    <filter-years
      v-if="filter.type === 'date'"
      v-show="filter.show"
      :options="filter"
      :parameter="filter.startParameter"      
      :title="filter.title"
    ></filter-years>
  </div>
</template>

<script>
import { FilterMultiSelect } from "@/components/index";
import { FilterCheckBox } from "@/components/index";
import { FilterCheckboxGroup } from "@/components/index";
import { FilterRange } from "@/components/index";
import { FilterDataQuality } from "@/components/index";
import { FilterYears } from "@/components/index";
export default {
  name: "TimeseriesFilter",
  components: {
    FilterMultiSelect,
    FilterRange,
    FilterCheckBox,
    FilterDataQuality,
    FilterYears,
    FilterCheckboxGroup
  },
  props: {
    filter: Object,
    filterCategory: Object,
    standaloneFilter: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>